export const SHIPS = [
  'AL',
  'AN',
  'AX',
  'AT',
  'FR',
  'ID',
  'IC',
  'LB',
  'CCA',
  'LAB',
  'NE',
  'HM',
  'OA',
  'SY',
  'AN',
  'OV',
  'QN',
  'SC',
  'BR',
  'JW',
  'RD',
  'SR',
  'MJ',
  'EN',
  'GR',
  'LG',
  'RH',
  'SP',
  'VI',
  'AD',
  'EX',
  'MA',
  'NV',
  'VY',
  'MS1',
  'MS2',
  'MS3',
  'MS4',
  'MS5',
  'MS6',
  'MR',
  'EG',
  'CS',
  'IN',
  'ML',
  'SM',
  'EC',
  'EQ',
  'RF',
  'SI',
  'SL',
  'ST',
  'XP',
  'XE',
  'XO',
  'BF',
  'HN',
  'OD',
  'OY',
  'MO',
  'SO',
  'SW',
  'ZT',
  'GE',
  'WN',
  'BY',
  'UT',
  'XC',
  'LE',
];

export const CHECKIN_SHIPS = [
  'AD',
  'AL',
  'AN',
  'AT',
  'AX',
  'BR',
  'CS',
  'EC',
  'EG',
  'EN',
  'EQ',
  'EX',
  'FR',
  'GR',
  'HM',
  'IC',
  'ID',
  'IN',
  'JW',
  'LB',
  'MA',
  'ML',
  'NV',
  'OA',
  'OV',
  'OY',
  'QN',
  'RD',
  'RF',
  'RH',
  'SC',
  'SI',
  'SL',
  'ST',
  'SM',
  'SR',
  'SY',
  'VI',
  'VY',
  'WN',
  'BY',
  'UT',
  'XC',
  'LE',
];

export const CHECKOUT_SHIPS = ['FR', 'EG', 'RD', 'HM', 'BY', 'AT', 'VI', 'OY'];
